module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Argentina_Brandsen_Building-Outside_2010-01-15_014.bc1e6c83.jpg";